import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const LoggedOutNotice = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex justify-content-center bg-light" style={{ paddingTop: '2rem' }}>
      <Card className="text-center shadow-sm" style={{ maxWidth: '400px' }}>
        <Card.Body className="p-4">
          <div className="mb-4">
            {/* You can add your logo here */}
            {/* <img src="/logo.png" alt="Logo" className="mb-4" style={{ height: '40px' }} /> */}
          </div>
          
          <h4 className="mb-3">You&apos;ve been logged out</h4>
          <p className="text-muted mb-4">
            Your session has expired due to inactivity. Please log in again to continue.
          </p>
          
          <Button 
            variant="primary" 
            onClick={() => navigate('/')}
            className="w-100"
          >
            Return to Login
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
};

export default LoggedOutNotice;